import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@store/api/baseQueries";

export const analyticsApi = createApi({
  reducerPath: "analyticsApi",
  baseQuery: customBaseQuery(
    fetchBaseQuery({
      baseUrl: `${process.env.REACT_APP_ZOOMAPP_BACKEND_BASE_URL}/meeting/analytics`,
    }),
  ),
  endpoints: (builder) => {
    return {
      startAnalytics: builder.mutation({
        query: (body) => ({
          url: "/start",
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body,
        }),
        transformResponse: (response) => response.data,
      }),

      stopAnalytics: builder.mutation({
        query: (body) => ({
          url: "/stop",
          method: "POST",
          body,
        }),
        transformResponse: (response) => response.data,
      }),
    };
  },
});

export const { useStartAnalyticsMutation, useStopAnalyticsMutation } =
  analyticsApi;
